module.exports = __webpack_public_path__ + "img/ic-screens.23be0d10.svg";